import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import cookie from "react-cookies";


import { getLoggedProfile } from "../../../actions/sessionAct";
import { setBooking, getCSDetail } from "../../../actions/csDetailAct";

import { getVehicleType } from "../../../model/car";

import { commonErr } from "../../common/errors";
import { stypes, formatTitleInUrl } from "../../common/common";
import { Loading } from "../../common/loading";
import { MessagePage } from "../../common/messagebox";

import Login from "../../login/login";
// import CarDetailHeader from "../../car/components/cardetailheader";
import CSDetailCover from "./components/cscover";
// import RelatedCars from "./relatedcars";
import SideBar from "./components/sidebar";


import { IcInstant, IcPhotos, IcIns } from "../../common/svg";
import {
	InfoCS,
	OutsFeatures,
    AdvantageCS,
	Policy,
	PaperCS
} from "./components/infocs";

import avatar_default from "../../../static/images/avatar_default.png";




class CSDetailPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			relatedList: [],
			isMCalendar: false
			
		};

	}

	componentDidMount() {
		const { skuGroupId } = this.props;
		const filter = this.props.csFinding.filter;

		let ex = {
			skuGroupId: skuGroupId, 
			st: filter.startDate.valueOf(),
			et: filter.endDate.valueOf(),
			// deliveryId: filter.deliveryId,
			vw: 'cd'
		}

		getVehicleType().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleTypes: resp.data.data.vehicleTypes,
				});
			}
		});


		if (filter.lat && filter.lng) {

			ex.lat = filter.lat
			ex.lon = filter.lng

            this.setBooking(ex)
			this.getCar(ex)
		} else if (filter.address && filter.address !== "") {
			searchInHouse(filter.address).then((response) => {
				if (response.data.error >= commonErr.SUCCESS && response.data.data && response.data.data.locations.length > 0) {
					const loc = response.data.data.locations[0];
					let latLng = { lat: loc.lat, lng: loc.lon };

					ex.lat = latLng.lat
					ex.lon = latLng.lng

                    this.setBooking(ex)
					this.getCar(ex)
				}
			});
		} else {
            this.setBooking(ex)
			this.getCar(ex)
		}

		// GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";

		window.gtag('event', "VIEW_CS_DETAIL", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: {source: utmSrc}
		});
		window.fbq('track', "VIEW_CS_DETAIL");
		window.addEventListener("resize", this.updateDimensions);
		this.checkWidthWindow()
	}

	componentDidUpdate(props) {
		const filter = props.csFinding.filter;
		const skuGroupId = props.skuGroupId;

		if (
			skuGroupId !== this.props.skuGroupId ||
			filter.address !== this.props.csFinding.filter.address ||
			filter.lat !== this.props.csFinding.filter.lat ||
			filter.lng !== this.props.csFinding.filter.lng
		) {

			let ex = {
				skuGroupId: this.props.skuGroupId, 
				st: filter.startDate.valueOf(),
				et: filter.endDate.valueOf(),
				// deliveryId: filter.deliveryId,
				vw: 'cd'
			}

			if (filter.lat && filter.lng) {
			
				ex.lat = filter.lat
				ex.lon = filter.lng

                this.setBooking(ex)
				this.getCar(ex)
			} else if (filter && filter.address !== "") {
				searchInHouse(filter.address).then((response) => {
					if (
						response.data.error >= commonErr.SUCCESS &&
						response.data.data &&
						response.data.data.locations.length > 0
					) {
						const loc = response.data.data.locations[0];
						let latLng = { lat: loc.lat, lng: loc.lon };

						ex.lat = latLng.lat
						ex.lon = latLng.lng

                        this.setBooking(ex)
						this.getCar(ex)
					}

				});
			} else {
			    this.setBooking(ex)
				this.getCar(ex)
			}

			// GA
			const utmSrc = cookie.load("_utm_src") || "web_directly";
			const utmExt = cookie.load("_utm_ext") || "no_label";
		
			window.gtag('event', "VIEW_CS_DETAIL", {
				event_category: utmSrc,
				event_label: utmExt,
				campaign: {source: utmSrc}
			});
			window.fbq('track', "VIEW_CS_DETAIL");
		}
	}

	getCar = (ex) => {
		this.setState({
			err: commonErr.LOADING,
		});
		this.props.dispatch(getCSDetail(ex)).then((resp) => {
			if (resp.action.payload.data.error === commonErr.SUCCESS) {
				this.setState({
					err: commonErr.SUCCESS,
				});
			}
		});
	};

    setBooking = (f) => {
		this.props.dispatch(setBooking(f));
	};

	checkWidthWindow = () => {
		if (window.innerWidth <= 991) {
			this.setState({
				isMCalendar: true
			})
		} else {
			this.setState({
				isMCalendar: false
			})
		}
	};

	updateDimensions = () => {
		this.checkWidthWindow()
	};


	isLogged = () => {
		return this.props.session.profile && this.props.session.profile.info && this.props.session.profile.info.uid;
	};

	showLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	showReportForm = () => {
		this.setState({
			showReportForm: true,
		});
	};

	closeReportForm = () => {
		this.setState({
			showReportForm: false,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	reportCarBtnClick = () => {
		if (!this.isLogged()) {
			this.showLoginForm();
		} else {
			this.showReportForm();
		}
	};

	updatePrice = (data) => {
		this.setState({
			csDetail: {
				info: data.car,
				priceOrigin: data.car.priceOrigin,
				profiles: data.profiles,
				relatedCars: data.cars,
				reviews: data.reviews,
				moreReview: data.moreReview,
			},
		});
	};



	render() {
		var content;
		const { err, csDetail, deliveryId, favWD, showReportForm, showLoginForm, isMCalendar, vehicleTypes } = this.state;

		if (err === commonErr.INNIT || err === commonErr.LOADING) {
			content = <Loading />
		} else if (err === commonErr.SUCCESS && this.props.csDetail.detail) {
		
			const loggedProfile = this.props.session.profile.info;
			const { info, profiles, relatedCars, cars } = this.props.csDetail.detail;
			var ownerProfile;
			let vehicleName;
			if (profiles && profiles.length > 0) {
				for (var i = 0; i < profiles.length; ++i) {
				if (profiles[i].uid === info.ownerId) {
						ownerProfile = profiles[i];
						break;
					}
				}
			}
			if (vehicleTypes && vehicleTypes.length > 0) {
				const vehicle = vehicleTypes.filter((type) => Number(type.id) == info.vehicleType);
				vehicleName = vehicle ? vehicle[0].name : ''
			}	


			content = (
				<div className="detail-car">
					{/* <Cover car={info} showLoginForm={this.showLoginForm} isLogged={this.isLogged()} stype={this.stype} /> */}
					<CSDetailCover info={info} />

					<div className="m-container">
						<div className="detail-container">
							<div className="content-detail">
                                <InfoCS info={info} vehicleName={vehicleName} />
							</div>
                            <SideBar
							    onReportCar={this.reportCarBtnClick}
                                closePopup={false}
                                detail={this.props.csDetail.detail}
                                owner={ownerProfile}
                                showLoginForm={this.openLoginForm}
                                loggedProfile={loggedProfile}
                                updatePrice={this.updatePrice}
                               
                                isMCalendar={isMCalendar}
                            />
                            <div className="content-detail">
                                <div className="line-page" />
                                <OutsFeatures info={info} vehicleName={vehicleName} />
                                <div className="line-page" />
								<PaperCS />
								<div className="line-page" />
								<Policy />
                                {/* <AdvantageCS /> */}
                            </div>

							<div className="clear"></div>
							{/* {this.isLogged() && <CarReport show={showReportForm} hideModal={this.closeReportForm} car={info} />} */}
							<Login
								show={showLoginForm}
								showModal={this.openLoginForm}
								hideModal={this.closeLoginForm}
								getLoggedProfile={this.getLoggedProfile}
							/>
						</div>
					</div>
					{/* {relatedList && relatedList.length > 0 && (
						<RelatedCars
							openNewWindow={true}
							isNewTab={false}
							cars={relatedList}
							togglePopup={this.props.togglePopup}
							stype={this.stype}
							showLoginForm={this.openLoginForm}
							isLogged={this.isLogged()}
						/>
					)} */}
				</div>
			);
		} else {
			content = <MessagePage message={"Không tìm thấy thông tin."} />;
		}

		return (
			<>
				<Modal show={this.props.show} onHide={this.props.onHide} dialogClassName="modal-dialog modal-car-detail">
					<Modal.Header closeButton={true} closeLabel={""}>
						{/* <CarDetailHeader stype={this.stype}/> */}
					</Modal.Header>
					<Modal.Body>{content}</Modal.Body>
				</Modal>
			</>
		);
	}
}

function mapState(state) {
	return {
		csFinding: state.csFinding,
		session: state.session,
		csDetail: state.csDetail
	};
}



CSDetailPopup = connect(mapState)(CSDetailPopup);

export default CSDetailPopup;
